<div class="cnt-participant">
  <hr />
  <ul>
    <li *ngFor="let item of participants">
      <span>{{item}}</span>
    </li>
  </ul>
</div>
